export default __webpack_public_path__ + "static/media/img5.730d4253.png";